exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question{color:#000}.question h4{font-weight:500;max-width:780px;margin:0 auto}.answers-section{background:#435a69;color:#fff;padding:80px}.answers-section label{text-align:left}@media (max-width:768px){.answers-section{padding:10px}}@media (min-width:768px){.answers label{font-size:25px}}@media (max-width:768px){.answers label{font-size:18px}}input.answer{display:none}input.answer+label{padding-left:0;position:relative;border:2px solid #fff;display:block;text-align:center;cursor:pointer;margin:20px 35px;font-size:19.6px;padding:10px}input.answer+label:hover{background:#f04e23;border-color:#f04e23}@media (max-width:768px){input.answer+label{padding:10px;margin:14px 10px}}input.answer:checked+label{background:#f04e23;border-color:#f04e23}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5dba4cc3","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/steps/Question.vue
// module id = 44
// module chunks = 0